import axios from 'axios';
import {authService} from '@services/auth.service';
import {API_URL} from './api.config';
import {attachSessionExpirationInterceptor} from './session-expiration';
import {getActiveTenantId, TENANT_HEADER} from '@utils/tenant';

export const createAuthenticatedApiClient = (options = {}) => {
    const {skipTenantHeader, ...axiosOptions} = options;
    const client = axios.create({
        baseURL: API_URL,
        headers: {
            'Content-Type': 'application/json'
        },
        ...axiosOptions
    });

    attachAuthInterceptors(client, {skipTenantHeader});
    attachSessionExpirationInterceptor(client);

    return client;
};

/** Cliente autenticado sin cabecera de clínica (endpoints globales de SuperAdmin). */
export const createAdminApiClient = () =>
    createAuthenticatedApiClient({skipTenantHeader: true});

/**
 * Cliente para `/portal-cliente/*`: el contexto va en el JWT (tenant_id + empresa_id),
 * no en X-Tenant-ID.
 */
export const createPortalApiClient = () =>
    createAuthenticatedApiClient({skipTenantHeader: true});

export const attachAuthInterceptors = (apiClient, options = {}) => {
    apiClient.interceptors.request.use(config => {
        const token = authService.getToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (!options.skipTenantHeader) {
            const tenantId = getActiveTenantId();

            if (tenantId) {
                config.headers[TENANT_HEADER] = String(tenantId);
            }
        }

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    });
};
